var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradsun512(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 212.84,
    y1: 272.94,
    x2: 239.44,
    y2: 511.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FCC793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101961,
    stopOpacity: 1,
    stopColor: "#FCC793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670588,
    stopOpacity: 1,
    stopColor: "#4362A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#2E5BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 108.5,
    x2: 256,
    y2: 383.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FFD35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#F9BEB2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id0)",
    fillRule: "nonzero",
    d: "M143.78 408.66c-5.27,6.29 -9.02,12.1 -11.14,17.62 -2.03,5.43 -3.04,11.43 -3.04,17.82 0,12.89 4.66,22.47 14.08,28.86 9.42,6.3 23.5,9.5 42.23,9.5 13.88,0 26.34,-2.23 37.38,-6.59 11.14,-4.26 21.27,-11.43 30.58,-21.4 9.32,-9.88 18.03,-24.7 26.04,-44.26 8,-19.57 15.59,-45.91 22.99,-79.03l-3.85 -2.52c-12.87,15.49 -24.82,27.6 -35.76,36.32 -11.04,8.71 -22.18,15.01 -33.42,18.88 -11.24,3.88 -24.11,5.81 -38.59,5.81 -13.67,0 -25.72,-3.1 -36.36,-9.39 -10.53,-6.2 -18.94,-16.08 -25.22,-29.64 -6.18,-13.56 -9.32,-30.7 -9.32,-51.52 0,-8.49 -0.16,-17.03 0.69,-25.46l82.97 -0.82c-1.67,11.56 -2.93,23.48 -2.93,33.93 0,13.85 2.12,24.12 6.38,30.99 4.25,6.78 10.83,10.17 19.75,10.17 8.5,0 17.11,-2.61 25.72,-7.75 8.71,-5.23 17.93,-13.26 27.45,-24.11 9.62,-10.95 17.72,-24.02 24.21,-39.32 0.41,-0.99 0.63,-1.75 1.05,-2.77l85.27 -0.23 -17.14 80.48c-5.17,23.63 -10.44,43 -15.7,58.11 -4.76,13.27 -10.03,24.5 -15.8,33.8 -5.07,8.71 -11.15,16.46 -18.03,23.24 -6.79,6.78 -13.98,12.59 -21.68,17.34 -8.1,5.13 -17.11,9.3 -27.04,12.78 -11.24,3.97 -23.8,6.98 -37.68,9.01 -14.79,2.32 -31.7,3.49 -50.74,3.49 -27.65,0 -50.95,-2.42 -69.89,-7.17 -18.84,-4.75 -32.92,-11.82 -42.13,-21.4 -9.22,-9.59 -13.78,-21.41 -13.78,-35.64 0,-11.72 4.36,-22.77 13.07,-33.13 8.71,-10.46 21.57,-20.34 38.59,-29.83l30.79 23.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M15.83 273.05c-8.72,0 -15.83,-7.08 -15.83,-15.77 0,-8.7 7.11,-15.78 15.83,-15.78l40.51 0c8.72,0 15.83,7.03 15.83,15.78 0,8.75 -7.11,15.77 -15.83,15.77l-40.51 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M455.66 273.05c-8.73,0 -15.83,-7.08 -15.83,-15.77 0,-8.7 7.1,-15.78 15.83,-15.78l40.51 0c8.72,0 15.83,7.03 15.83,15.78 0,8.75 -7.11,15.77 -15.83,15.77l-40.51 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M34.1 155.2c-7.65,-4.4 -10.28,-14.19 -5.86,-21.82 4.42,-7.63 14.25,-10.25 21.9,-5.85l35.52 20.44c7.66,4.4 10.32,14.14 5.87,21.82 -4.44,7.68 -14.25,10.25 -21.9,5.85l-35.53 -20.44 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M239.67 15.98c0,-8.81 7.2,-15.98 16.04,-15.98 8.83,0 16.03,7.17 16.03,15.98l0 40.87c0,8.81 -7.2,15.98 -16.03,15.98 -8.84,0 -16.04,-7.11 -16.04,-15.98l0 -40.87 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M122.77 54.94c-4.41,-7.63 -1.78,-17.42 5.87,-21.83 7.66,-4.4 17.49,-1.78 21.91,5.85l20.51 35.4c4.42,7.63 1.83,17.39 -5.87,21.82 -7.7,4.43 -17.48,1.78 -21.9,-5.85l-20.52 -35.39 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M477.31 155.2c7.65,-4.4 10.29,-14.19 5.87,-21.82 -4.42,-7.63 -14.25,-10.25 -21.91,-5.85l-35.52 20.44c-7.66,4.4 -10.32,14.14 -5.87,21.82 4.45,7.68 14.25,10.25 21.9,5.85l35.53 -20.44 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD35C",
    fillRule: "nonzero",
    d: "M388.65 54.94c4.42,-7.63 1.78,-17.42 -5.87,-21.83 -7.66,-4.4 -17.49,-1.78 -21.9,5.85l-20.51 35.4c-4.42,7.63 -1.84,17.39 5.86,21.82 7.71,4.43 17.49,1.78 21.91,-5.85l20.51 -35.39 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id1)",
    d: "M256 108.5c76.09,0 137.78,61.47 137.78,137.29 0,9.66 -1.01,19.09 -2.91,28.19l-85.2 0c6.04,-14.81 11.38,-33.17 16.19,-54.92l2.32 -10.46c3.22,-14.04 4.74,-27.6 4.74,-40.87 0,-13.08 -2.42,-22.76 -7.36,-29.25 -4.94,-6.39 -13.01,-9.59 -24.2,-9.59 -17.74,0 -33.67,8.43 -47.89,25.47 -14.11,17.05 -25.7,40.68 -34.67,71 -5.11,17.17 -8.74,33.38 -10.93,48.62l-82.74 0c-1.9,-9.1 -2.91,-18.53 -2.91,-28.19 0,-75.82 61.69,-137.29 137.78,-137.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradsun512);
export default __webpack_public_path__ + "static/media/gradsun512.3c74bf17899cb24ff43e488491e5bbb7.svg";
export { ForwardRef as ReactComponent };